//----- Component --------------------------------------------------------/

// Developer :  Nicolas Pascucci

// Creation Date : 11/02/2025

// Version : 1

// Description : Reingreso de un articulo desde un vehiculo a una sucursal

//

//------Changes --------------------------------------------------------------------- -------------//

// Change Date :

// Change by :

// Change description:

//

// Change Date :

// Change by :

// Change description:

//
//========================================================================/
import React, { useRef } from "react";
import { useEffect, useState } from "react";
import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  Autocomplete,
  Grid,
  Stack,
  Snackbar,
  Alert,
} from "@mui/material";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { getData, postData, putData } from "../../../services/library";
import { UrlApi } from "../../../services/apirest";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";

function ReingresoStock(props) {
      const [notificacion, setNotificacion] = useState({
        open: false,
        mensaje: "",
        severity: "",
        color: "",
      });
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [datos, setDatos] = useState({
    cantidad: 1,
  });
    const [uuidDoc, setUuidDoc] = useState(uuidv4());
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [cantidadNueva, setCantidadNueva] = useState(0);
  const [articulosEspecificos, setArticulosEspecificos] = useState();
  const [articuloEspecificoSeleccionado, setArticuloEspecificoSeleccionado] =
    useState({});
  const [sucursales, setSucursales] = useState();
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState({});
  const [almacenes, setAlmacenes] = useState();
  const [almacenSeleccionado, setAlmacenSeleccionado] = useState({});
  const [buscandoAlmacen, setBuscandoAlmacen] = useState(false);
  const [buscandoSucursales, setBuscandoSucursales] = useState(false);
  const [inventario, setInventario] = useState([]);
  const [inventarioAlmacen, setInventarioAlmacen] = useState([]);
  const [uuid, setUuid] = useState(uuidv4());
  const [posicionEspecifica, setPosicionEspecifica] = useState([])
  // console.log(sucursalSeleccionada);

  useEffect(() => {
    setCantidadNueva(parseInt(props.row.cantidad) - parseInt(datos.cantidad));
  }, [datos.cantidad]);

  const obtenerSucursales = () => {
    getData("/sucursales", setSucursales);
  };

  const obtenerArtEspecificos = () => {
    getData(
      "/stock_seguimiento/detalle/" +
        props.row.articulo +
        "/" +
        props.row.vehiculo,
      setArticulosEspecificos
    );
  };

  const obtenerAlmacenes = () => {
    setBuscandoAlmacen(true);
    getData(
      "/stock_almacenes/xsucursal/" + sucursalSeleccionada.id,
      setAlmacenes,
      setBuscandoAlmacen(false)
    );
  };

  const obtenerInventario = () => {
    fetch(
      UrlApi +
        "/stock_inventarios/xalmart/" +
        almacenSeleccionado.id_almacen +
        "/" +
        props.row.articulo
    )
      .then((data) => data.json())
      .then((data) => setInventarioAlmacen(data));
  };
// console.log("props.vehiculo", props.vehiculo);

  const obtenerPosicionEspecifico = () => {
    getData("/stock_posiciones/especificos/"+props.vehiculo+"/"+props.row.articulo+"/"+articuloEspecificoSeleccionado.identificador,setPosicionEspecifica)
  }
  useEffect(() => {
    getData(
      "/stock_vehiculos/artyvehic/" + props.row.articulo + "/" + props.vehiculo,
      setInventario
    );
  }, []);

  useEffect(() => {
    obtenerInventario();
  }, [almacenSeleccionado.id_almacen]);

  useEffect(() => {
    obtenerArtEspecificos();
    obtenerSucursales();
  }, []);

  useEffect(() => {
    obtenerAlmacenes();
  }, [sucursalSeleccionada]);

  useEffect(() => {
    obtenerPosicionEspecifico()
  }, [articuloEspecificoSeleccionado])
  // console.log("pos", posicionEspecifica);
  
  //Snackbar Notificacion
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
    props.onClose(false);
  };

  // console.log("props", props.row);
  const almacenar = (e) => {
    setDatos({
      ...datos,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    // Verifica si la sucursal y el almacén están seleccionados
    const sucursalValida = Object.keys(sucursalSeleccionada).length > 0;
    const almacenValido = Object.keys(almacenSeleccionado).length > 0;
  
    // Verifica si la cantidad es válida
    const cantidadValida = !isNaN(parseInt(datos.cantidad)) && cantidadNueva >= 0;
  
    // Deshabilita el botón si alguna de las condiciones no se cumple
    setDeshabilitado(!(sucursalValida && almacenValido && cantidadValida));
  }, [sucursalSeleccionada, almacenSeleccionado, datos.cantidad, cantidadNueva]);
  
  // ******************** REQUERIMIENTOS Y MAIL ******************** //
  const [usuarioCompras, setUsuarioCompras] = useState([]);

  const obtenerUsuarioCompras = () => {
    fetch(UrlApi + "/userdata/sector/4/")
      .then((data) => data.json())
      .then((data) => setUsuarioCompras(data));
  };

  useEffect(() => {
    obtenerUsuarioCompras();
  }, []);

  const [reqExiste, setReqExiste] = useState([]);

  const obtenerRequerimientoExistente = () => {
    fetch(
      UrlApi +
        "/requerimientos_materiales/reqexiste/" +
        sucursalSeleccionada.id +
        "/" +
        props.row.articulo
    )
      .then((data) => data.json())
      .then((data) => setReqExiste(data));
  };

  useEffect(() => {
    obtenerRequerimientoExistente();
  }, [sucursalSeleccionada]);

    const [envioRequerimiento, setEnvioRequerimiento] = useState({
      id_movil: null,
      id_sucursal: sucursalSeleccionada.id,
      fecha_entrega: moment(datos.fecha).format("YYYY-MM-DD HH:mm:ss"),
      usuario_registra: localStorage.getItem("user"),
      usuario_autoriza: null,
      estado: 50, //cuando se carga el pedido se pone en estado "A autorizar"
      para_comprar: 1,
      observaciones: "",
      uuid_requerimiento: uuid,
      comentarios_internos: "Pedido Automático - Definir Cantidad",
      para_compras: 0,
      para_rrhh: 0,
      autorizado_jefe_compras: 0,
    });
  
    const [datosLista, setDatosLista] = useState([
      {
        material: null,
        usuario: localStorage.getItem("user"),
        cantidad: 1,
        // id_unidad_medida: datosArt.id_unidad_medida,
        uuid_requerimiento: envioRequerimiento.uuid_requerimiento,
        id_articulo: props.row.articulo,
      },
    ]);
  
    useEffect(() => {
      setDatosLista([
        {
          material: null,
          usuario: localStorage.getItem("user"),
          cantidad: 1,
          // id_unidad_medida: datosArt.id_unidad_medida,
          uuid_requerimiento: envioRequerimiento.uuid_requerimiento,
          id_articulo: props.row.articulo,
        },
      ]);
      setEnvioRequerimiento({
        id_movil: null,
        id_sucursal: sucursalSeleccionada.id,
        fecha_entrega: moment(datos.fecha).format("YYYY-MM-DD HH:mm:ss"),
        usuario_registra: localStorage.getItem("user"),
        usuario_autoriza: null,
        estado: 50, //cuando se carga el pedido se pone en estado "A autorizar"
        para_comprar: 1,
        observaciones: "",
        uuid_requerimiento: uuid,
        comentarios_internos: "Pedido Automático - Definir Cantidad",
        para_compras: 0,
        para_rrhh: 0,
        autorizado_jefe_compras: 0,
      });
    }, [datos, sucursalSeleccionada]);

      const guardarListaMateriales = (e) => {
        postData(
          e,
          "/lista_materiales",
          {
            datosLista,
          },
          setNotificacion
        );
      };

//CANTIDADES
//  restar cantidad al vehiculo
    const [cantidadInventario, setCantidadInventario] = useState(0);
    useEffect(() => {
      setCantidadInventario(
        inventario[0]
          ? parseInt(inventario[0].cantidad) - parseInt(datos.cantidad)
          : null
      );
    }, [inventario, datos.cantidad]);
  
// sumar cantidad al almacen
    const [cantidadAlmacen, setCantidadAlmacen] = useState(0);
    useEffect(() => {
      setCantidadAlmacen(
        inventarioAlmacen[0]
          ? parseInt(inventarioAlmacen[0].cantidad) + parseInt(datos.cantidad)
          : "null"
      );
    }, [inventarioAlmacen, datos.cantidad]);

    // console.log("inventario vehiculo", inventario, "cantidad nueva", cantidadInventario);
    // console.log("inventario almacen", inventarioAlmacen,"cantidad almacen nueva", cantidadAlmacen);
    //funciones de guardado
    const guardarHistorialVehiculo = async () => {
        try {
            const res = await fetch(UrlApi + "/stock_vehiculo_historial", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    vehiculo: props.vehiculo,
                    articulo: props.row.articulo,
                    cantidad: datos.cantidad,
                    tipo: 3,
                    fecha: moment().format(
                      "YYYY-MM-DD HH:mm:ss"
                    ),
                    almacen_origen: almacenSeleccionado.id_almacen,
                    usuario: localStorage.getItem("user"),
                    detalle: datos.detalle,
                    identificador: articuloEspecificoSeleccionado?.identificador,
                    // km_inicial: datos.km_inicial
                })
            });
            if (!res.err) {
                setOpenSnack(true);
                setColorMensaje("#D4EFDF");
                setMensaje("El artículo se guardó exitosamente !");
            } else {
                throw new Error("Error al guardar el artículo");
            }
        } catch (error) {
            console.error(error.message);
        }
    };
    
    const guardarStockVehiculo = async () => {
        try {
            const url =  UrlApi + "/stock_vehiculos/" + inventario[0].id;
            
            const method = "PUT";
            
            const res = await fetch(url, {
                method,
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    cantidad: cantidadInventario,
                    usuario: localStorage.getItem("user"),
                    vehiculo: props.vehiculo,
                    articulo: props.row.articulo,
                })
            });
            
            if (!res.err) {
                setOpenSnack(true);
                setColorMensaje("#D4EFDF");
                setMensaje("El artículo se asignó exitosamente !");
            } else {
                throw new Error("Error al asignar el artículo");
            }
        } catch (error) {
            console.error(error.message);
        }
    };
    
    const registrarTransaccionIngreso = async () => {
        try {
            await fetch(UrlApi + "/stock_transacciones", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    id_accion: 158,
                    // id_proveedor: proveedorSeleccionado.id,
                    id_articulo: props.row.articulo,
                    almacen_destino: almacenSeleccionado.id_almacen,
                    cantidad_recibida: datos.cantidad,
                    detalle_transaccion: "Reingreso desde Vehiculo",
                    // nro_remito_puntodeventa: datosArt.nro_remito_puntodeventa,
                    // nro_remito_numero: datosArt.nro_remito_numero,
                    fecha_transaccion: moment().format(
                      "YYYY-MM-DD HH:mm:ss"
                    ),
                    usuario: localStorage.getItem("user"),
                    uuid_documentacion: uuidDoc, //ADJUNTAR IMAGEN
                })
            });
        } catch (error) {
            console.error(error.message);
        }
    };
    
    const actualizarInventarioAlmacen = async () => {
        try {
            if (inventarioAlmacen.length === 0) {
                  await fetch(UrlApi + "/stock_inventarios", {
                    // PUT SI YA EXISTE / POST SI ES NUEVO
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                      id_articulo: props.row.articulo,
                      cantidad: datos.cantidad,
                      id_almacen: almacenSeleccionado.id_almacen,
                      usuario: localStorage.getItem("user"),
                    }),
                  })
                    .then((res) => {
                      if (!res.err) {
                        setOpenSnack(true);
                        setColorMensaje("#D4EFDF");
                        setMensaje("El artículo se guardó exitosamente !");
                      } else {
                        setOpenSnack(false);
                        setColorMensaje("#F1948A");
                        setMensaje("Error al guardar el artículo");
                      }
                    })
                    .catch((err) => {
                      console.log(err.message);
                    });
                  // handleClickOpenCrear();
                } else {
                  await fetch(
                    UrlApi +
                      "/stock_inventarios/" +
                      almacenSeleccionado.id_almacen +
                      "/" +
                      props.row.articulo,
                    {
                      // PUT SI YA EXISTE / POST SI ES NUEVO
                      method: "PUT",
                      headers: { "Content-Type": "application/json" },
                      body: JSON.stringify({
                        cantidad: cantidadAlmacen,
                        usuario: localStorage.getItem("user"),
                      }),
                    }
                  )
                    .then((res) => {
                      if (!res.err) {
                        setOpenSnack(true);
                        setColorMensaje("#D4EFDF");
                        setMensaje("El artículo se guardó exitosamente !");
                      } else {
                        setOpenSnack(false);
                        setColorMensaje("#F1948A");
                        setMensaje("Error al guardar el artículo");
                      }
                    })
                    .catch((err) => {
                      console.log(err.message);
                    });
                }
        } catch (error) {
            console.error(error.message);
        }
    };

    const bajaArticuloEspecifico = async () => {
      if (datos.cantidad === 1 || datos.cantidad === "1") {
        if (Object.keys(articuloEspecificoSeleccionado).length === 0) {
          console.log(".");
        } else {
          // putData("/stock_seguimiento/" + articuloEspecificoSeleccionado.id, {
          //   baja: 1,
          // });
          await fetch(
                  UrlApi +
                    "/stock_seguimiento/" + articuloEspecificoSeleccionado.id,
                  {
                    // PUT SI YA EXISTE / POST SI ES NUEVO
                    method: "PUT",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                      baja: 1,
                    }),
                  }
                )
                  .then((res) => {
                    if (!res.err) {
                      setOpenSnack(true);
                      setColorMensaje("#D4EFDF");
                      setMensaje("El artículo se guardó exitosamente !");
                    } else {
                      setOpenSnack(false);
                      setColorMensaje("#F1948A");
                      setMensaje("Error al guardar el artículo");
                    }
                  })
                  .catch((err) => {
                    console.log(err.message);
                  });
        }
      } else {
        console.log(".");
      }
    }

    const quitaPosicion = async () =>{
      if (Object.keys(articuloEspecificoSeleccionado).length === 0) {
        console.log("."); 
      } else if (posicionEspecifica.length > 0){
        await fetch(
          UrlApi +
            "/stock_posiciones/" + posicionEspecifica[0].id,
          {
            // PUT SI YA EXISTE / POST SI ES NUEVO
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              activo: 0,
            }),
          }
        )
          .then((res) => {
            if (!res.err) {
              setOpenSnack(true);
              setColorMensaje("#D4EFDF");
              setMensaje("la posicion se dió de baja exitosamente !");
            } else {
              setOpenSnack(false);
              setColorMensaje("#F1948A");
              setMensaje("Error al dar de baja la posicion");
            }
          })
          .catch((err) => {
            console.log(err.message);
          });
      }
    }
    // console.log("articuloEspecificoSeleccionado", articuloEspecificoSeleccionado);
    // console.log("row", props.row);
    
    
    const manejarPedidoAutomatico = async () => {
        if (props.row.pedido_automatico === 1 && reqExiste.length === 0) {
            await postData(null, "/requerimientos_materiales", {
                id_sucursal: envioRequerimiento.id_sucursal,
                id_movil: envioRequerimiento.id_movil,
                estado: 50,
                para_comprar: envioRequerimiento.para_comprar,
                para_compras: envioRequerimiento.para_compras,
                para_rrhh: envioRequerimiento.para_rrhh,
                fecha_entrega: envioRequerimiento.fecha_entrega,
                usuario_registra: envioRequerimiento.usuario_registra,
                usuario_autoriza: envioRequerimiento.username,
                observaciones: envioRequerimiento.observaciones,
                uuid_requerimiento: uuid,
                comentarios_internos: envioRequerimiento.comentarios_internos,
                autorizado_jefe_compras: 0,
            }, setNotificacion, guardarListaMateriales(null));
        }
    };
    
    const handleGuardar = async (e) => {
        e.preventDefault();
        await guardarHistorialVehiculo();
        await guardarStockVehiculo();
        await registrarTransaccionIngreso();
        await actualizarInventarioAlmacen();
        await bajaArticuloEspecifico();
        await manejarPedidoAutomatico();
        await quitaPosicion();
    };
    
  return (
    <>
      <Dialog
        fullWidth
        open={props.open}
        onClose={() => props.onClose(false)}
        maxWidth="md"
      >
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography fontSize={20} align="center" color="#ffffff">
              Reingresar {props.row.nombre} a sucursal
            </Typography>
          </DialogTitle>
        </Box>
        <form>
          <DialogContent>
            <Grid container spacing={1}>
              <Grid
                item
                xs={datos.cantidad === 1 || datos.cantidad === "1" ? 3 : 6}
                // xs={4.5}
              >
                <TextField
                  label="Existencia"
                  name="existencia"
                  size="small"
                  type="number"
                  focused
                  required
                  fullWidth
                  autoComplete="off"
                  value={props.row.cantidad}
                  // onChange={almacenar}
                  disabled
                  //   error={!!erroresStock[index]}  // Cambia a rojo si hay error
                />
              </Grid>
              <Grid
                item
                xs={datos.cantidad === 1 || datos.cantidad === "1" ? 3 : 6}
                // xs={4.5}
              >
                <TextField
                  label="Cantidad a Reingresar"
                  name="cantidad"
                  size="small"
                  type="number"
                  focused
                  required
                  fullWidth
                  autoComplete="off"
                  value={datos.cantidad}
                  onChange={almacenar}
                  error={cantidadNueva < 0 ? true : false} // Cambia a rojo si hay error
                />
              </Grid>
              {datos.cantidad === 1 || datos.cantidad === "1" ? (
                <Grid item xs={6}>
                  {/* {openSnack ? (
                    <TextField
                      disabled
                      focused
                      fullWidth
                      size="small"
                      label="Guardando..."
                    />
                  ) : ( */}
                  <Autocomplete
                    disabled={!articulosEspecificos}
                    disableClearable
                    size="small"
                    required
                    noOptionsText={"Identificador INEXISTENTE"}
                    options={articulosEspecificos}
                    autoHighlight
                    getOptionLabel={(articulo) => articulo.identificador}
                    //   value={getProductoById(linea.producto)}
                    onChange={(event, value) => {
                      setArticuloEspecificoSeleccionado(value);
                      // setBuscandoSucursales(true)
                      // setBuscandoAlmacen(true)
                    }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{
                          "& > img": { mr: 2, flexShrink: 0 },
                        }}
                        {...props}
                      >
                        {option.identificador}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        inputProps={{
                          ...params.inputProps,
                        }}
                        focused
                        size="small"
                        placeholder="Tipee para buscar..."
                        label="Identificador"
                        // error={!!erroresStock[index]}
                      />
                    )}
                  />
                  {/* )} */}
                </Grid>
              ) : null}
              <Grid item xs={6}>
                {openSnack ? (
                  <TextField
                    disabled
                    focused
                    fullWidth
                    size="small"
                    label="Guardando..."
                  />
                ) : buscandoSucursales ? (
                  <TextField
                    disabled
                    focused
                    fullWidth
                    size="small"
                    label="Buscando Sucursales..."
                  />
                ) : (
                  <Autocomplete
                    disabled={!sucursales}
                    size="small"
                    focused
                    disableClearable
                    id="sucursal"
                    noOptionsText={"Sucursal INEXISTENTE"}
                    options={sucursales}
                    autoHighlight
                    getOptionLabel={(sucursal) =>
                      sucursal.id + "-" + sucursal.nombre
                    }
                    onChange={(event, value) => {
                      setSucursalSeleccionada(value);
                      setBuscandoAlmacen(true);
                    }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.id} - {option.nombre}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        inputProps={{
                          ...params.inputProps,
                        }}
                        focused
                        required
                        size="small"
                        placeholder="Tipee para buscar..."
                        label="Sucursal"
                        //   helperText={erroresStock[index] || ""}  // Muestra el mensaje de error si hay
                        //   error={!!erroresStock[index]}
                      />
                    )}
                  />
                )}
              </Grid>
              <Grid item xs={6}>
                {openSnack ? (
                  <TextField
                    disabled
                    focused
                    fullWidth
                    size="small"
                    label="Guardando..."
                  />
                ) : buscandoAlmacen ? (
                  <TextField
                    disabled
                    focused
                    fullWidth
                    size="small"
                    label="Buscando Almacenes..."
                  />
                ) : (
                  <Autocomplete
                    disabled={almacenes === "" ? true : false}
                    size="small"
                    focused
                    disableClearable
                    id="stock_almacenes"
                    noOptionsText={"Almacén INEXISTENTE"}
                    options={almacenes}
                    autoHighlight
                    getOptionLabel={(almacenes) =>
                      almacenes.id_almacen + "-" + almacenes.nombre
                    }
                    onChange={(event, value) => {
                      setAlmacenSeleccionado(value);
                    }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.id_almacen} - {option.nombre}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        inputProps={{
                          ...params.inputProps,
                        }}
                        required
                        focused
                        size="small"
                        placeholder="Tipee para buscar..."
                        label="Almacén"
                        //   helperText={erroresStock[index] || ""}  // Muestra el mensaje de error si hay
                        //   error={!!erroresStock[index]}
                      />
                    )}
                  />
                )}
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              mt={3}
            >
              <Grid item>
                <Button
                  color="error"
                  variant="outlined"
                  onClick={() => props.onClose(false)}
                  style={{ backgroundColor: "#fff" }}
                >
                  Volver
                </Button>
              </Grid>
              <Grid item>
                <Button
                  // type="submit"
                  //   disabled={disabled}
                  color="success"
                  variant="contained"
                  disabled={deshabilitado}
                  // endIcon={<SaveIcon />}
                    onClick={handleGuardar}
                >
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </DialogContent>
        </form>
      </Dialog>
      {/* GUARDAR AL CREAR */}
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default ReingresoStock;
